module.exports = __webpack_public_path__ + "img/strength_icon2.6a48cd1e.png";